// extracted by mini-css-extract-plugin
export var typingIndicator = "_s6-0";